.action-block {
  box-sizing: border-box;
  flex: 1;
  min-height: 130px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 28px;
}

.action-block *,
.action-block *::before,
.action-block *::after {
  box-sizing: inherit;
}

.action-block--small .action-block__heading,
.action-block--small .action-block__text {
  font-size: 13px;
  line-height: 15px;
}

.action-block__heading {
  font-size: 16px;
  line-height: 25px;
  margin: 0 0 8px;
  color: #333333;
  text-align: center;
  max-width: 100%;
}

.action-block__text-content {
  background: none;
  color: #42b4e6;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: inherit;
  font-family: inherit;
  font-size: 15px;
  line-height: 20px;
  font-weight: normal;
  text-align: center;
}

.action-block__text-content:hover {
  text-decoration: underline;
}

.action-block__text-content:hover {
  text-decoration: none;
}

.action-block__text {
  display: inline;
  text-transform: capitalize;
}

.action-block:hover .action-block__text {
  text-decoration: underline;
}

.action-block__text-arrow-icon {
  display: inline-flex;
  align-items: center;
  height: 20px;
  width: 20px;
  vertical-align: middle;
  position: relative;
  bottom: 1px;
}

:host(:not([dir="rtl"])) .action-block__text-arrow-icon {
  left: 2px;
}

:host([dir="rtl"]) .action-block__text-arrow-icon {
  right: 2px;
  transform: scaleX(-1);
}